module.exports = __webpack_public_path__ + "static/media/umaCasaLogo.9a3f8a23.svg";